import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Constants from "../../util/Constants";
import Util from "../../util/Util";
import Display from "../../util/Display";
import { Table } from "react-bootstrap";
import { FaDownload, FaTrash } from "react-icons/fa";
import { reactLocalStorage } from "reactjs-localstorage";
import DocumentAPI from "../../api/DocumentAPI";

export function MyGallery({ media, className, document, reload, canDelete }) {
  const ImagesTypes = Constants.FileUploadType[0];
  const VideoTypes = Constants.FileUploadType[1];
  const mediaList = [];
  const onDelete = (id) => {
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        DocumentAPI.delete(
          id,
          onDeleteSuccess,
          () => { }
        );
      }
    );
  };
  const onDeleteSuccess = (res) => {
    Util.showNotification(
      "Successful",
      "Documnet deleted successfully",
      "success"
    );
    reload();
  };
  media.forEach((item) => {
    const isImage = ImagesTypes.find((type) => item.file_type === type);
    const isVideo = VideoTypes.find((type) => item.file_type === type);

    if (isImage) {
      mediaList.push({
        original: item.url,
        thumbnail: item.url,
        renderItem: () => (
          <div>
            <img
              src={item.url}
              alt=""
              style={{ width: "100%", height: "400px", objectFit: "contain" }}
            />

            {canDelete ? (
              <button
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  cursor: "pointer",
                }}
                onClick={() => onDelete(item?.document_id ?? item.id)}
                className="buttons delete"
              >
                <FaTrash /> Delete
              </button>
            ): null}
          </div>
        ),
        originalHeight: 400,
        originalWidth: 400,
        thumbnailHeight: 60,
        thumbnailWidth: 40,
      });
    } else if (isVideo) {
      mediaList.push({
        original: item.url,
        thumbnail: item.url,
        renderItem: () => (
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <video
              controls
              style={{ width: "100%", height: "100%", maxHeight: 400, objectFit: "contain", overflow: "hidden" }}
              id={`video-${item.url}`}
            >
              <source src={item.url} type={`video/${item.file_type}`} />
              Your browser does not support the video tag.
            </video>

            {canDelete ? (
              <button
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  cursor: "pointer",
                }}
                onClick={() => onDelete(item?.document_id ?? item.id)}
                className="buttons delete"
              >
                <FaTrash /> Delete
              </button>
            ) : null}
          </div>
        ),
        originalHeight: 400,
        originalWidth: 400,
        thumbnailHeight: 60,
        thumbnailWidth: 40,
      });
    }
  });

  return (
    <ReactImageGallery
      items={mediaList}
      thumbnailPosition="bottom"
      showThumbnails={true}
      additionalClass={className}
      lazyLoad={true}
      showBullets={true}
      showPlayButton={media.length > 1 ? true : false}
      showFullscreenButton={true}
      useBrowserFullscreen={false}
    />
  );
}


export function DocTable({ media, documents, reload }) {
  const model = reactLocalStorage.getObject(Constants.Model).document;
  const Delete = Util.isAllow(model.permission, Constants.PermDelete);
  let document = [];
  documents.forEach((item) => {
    item.images.forEach((doc) => {
      if (Constants.FileUploadType[2].includes(doc.file_type)) document.push(doc);
    });
  });
  const onDeleteSuccess = () => {
    Util.showNotification(
      "Successful",
      "Documnet deleted successfully",
      "success"
    );
    reload();
  };
  const onDelete = (id) => {
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        DocumentAPI.delete(
          id,
          onDeleteSuccess,
          () => { }
        );
      }
    );
  };

  const showList = () => {
    const docs = [];
    for (let i = 0; i < documents.length; i++) {
      const doc = documents[i];
      const files = doc.images;
      if (files.length === 0) {
        continue;
      }
      files.forEach((file) => {
        if (Constants.FileUploadType[2].includes(file.file_type))
          docs.push(
            <tr key={`document_${i + 1}`}>
              <td>{Display.FieldValue(doc, "file_type", model.fields)}</td>
              <td>{Display.FieldValue(doc, "description", model.fields)}</td>
              <td>
                <a
                  className="buttons add"
                  href={file.url}
                  target="_target"
                  rel="noreferrer">
                  View
                </a>
              </td>
              <td>{Util.serverStringToDisplayDateTime(doc.created_date)}</td>
              <td>{Display.ModelLabelValue("user", doc.created_by)}</td>
              <td>
                {Delete && (
                  <span onClick={() => onDelete(doc.id)} className="buttons delete">
                    <FaTrash /> Delete
                  </span>
                )}
              </td>
            </tr>
          );
      });

    }
    return docs;
  };
  let uiDocuments = showList();
  if (media.length === 0) {
    uiDocuments = (
      <tr>
        <td colSpan="6">No Records Found</td>
      </tr>
    );
  }
  return (
    <Table striped bordered responsive hover size="sm">
      <thead>
        <tr>
          <th>File Type</th>
          <th>Description</th>
          <th>Download</th>
          <th>Created Date</th>
          <th>Created By</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>{uiDocuments}</tbody>
    </Table>
  );
}